export enum ViewMode {
    Monitors = 1,
    Calendar = 2,
    List = 3,
    FullScreen = 4,
    MonitorsSmall = 5
}
